import { Router } from "@angular/router";
import { first } from "rxjs/operators";
import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { RequestInstanceDTO } from "src/app/parametrage/core/model/request-instance-dto";
import { UserService } from "src/app/shared/directives/user.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { DetenteurComponent } from "src/app/formulaire/modal/detenteur/detenteur.component";
import { SuiviComponent } from "src/app/formulaire/modal/suivi/suivi.component";
import { FormulaireDTO } from "src/app/parametrage/core/model/formulaire-dto";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { ProfessionnelService } from "../../core/service/professionnel.service";
import { LibererDossier } from "src/app/parametrage/core/model/request/liberer-dossier";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { AbandonnerDossierComponent } from "src/app/formulaire/modal/abandonner-dossier/abandonner-dossier.component";
import { ChangerInitiateurDossierComponent } from "src/app/formulaire/modal/changer-initiateur-dossier/changer-initiateur-dossier.component";
import { RepartiteurService } from 'src/app/mon-portefeuille/core/service/repartiteur.service';

@Component({
  selector: "app-en-cours",
  templateUrl: "./en-cours.component.html",
  styleUrls: ["./en-cours.component.scss"],
})
export class EnCoursComponent implements OnInit {
  isLoadingResults = true;

  MyPermissions: string[];

  private userPermission = {
    permissions: [],
  };

  dossiers: RequestInstanceDTO[];
  formulaire: FormulaireDTO;

  page: number = 1;
  totalElements: number = 0;
  filter: String = "";

  libererDossier: LibererDossier;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private userService: UserService,
    private _keycloakService: KeycloakService,
    private _professionnelService: ProfessionnelService,
    private _formulaireService: FormulaireService,
    private _requestService: RequestService,
    private _repartiteurService : RepartiteurService
  ) {
    this.MyPermissions = _keycloakService.getAccessPermissions();
    this.userPermission.permissions = this.MyPermissions;
    this.userService.setUser(this.userPermission);
  }

  ngOnInit() {
    this.getAll(this.filter, 0, 5);
  }

  getAll(filter, page, size) {
    this.isLoadingResults = true;

    this._professionnelService
      .findAllDossierEncours(filter, page, size)
      .subscribe(
        (data) => {
          this.isLoadingResults = false;
          this.dossiers = data.content;
          this.totalElements = data.totalElements;
        },
        (error) => {
          console.log(error);
          this.isLoadingResults = false;
        }
      );
  }

  loadPage(page: number): void {
    page = page - 1;
    this.getAll(this.filter, page, 5);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter = filterValue;
    this.page = 0;
    this.getAll(this.filter, this.page, 5);
  }

  searchAndRefresh(): void {
    this.getAll(this.filter, 0, 5);
  }

  dossierInfo(requestId) {
    this._formulaireService.takeFormInfoRequest(requestId).subscribe(
      (data) => {
        this.formulaire = data;
        this._router.navigateByUrl(this.formulaire.url);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  userByRole(requestId) {
    const modalRef = this.modalService.open(DetenteurComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {},
      (reason) => {}
    );
  }

  suivi(requestId) {
    const modalRef = this.modalService.open(SuiviComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {}
    );
  }

  liberer(requestId): void {
    this.libererDossier = new LibererDossier();
    this.libererDossier.requestId = requestId;
    this._requestService
      .liberer(this.libererDossier)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getAll(this.filter, this.page - 1, 5);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  abandonner(requestId) {
    const modalRef = this.modalService.open(AbandonnerDossierComponent, {
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        this.getAll(this.filter, this.page - 1, 5);
      },
      (reason) => {}
    );
  }

  changerInitiateur(requestId) {
    const modalRef = this.modalService.open(ChangerInitiateurDossierComponent, {
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        this.getAll(this.filter, this.page - 1, 5);
      },
      (reason) => {}
    );
  }
  
  assigneTaskForCurrentRequest(requestId) {
    this._repartiteurService.assigneTaskForCurrentRequest(requestId).subscribe(
      (data) => {
        this.getAll(this.filter, this.page - 1, 5);
      },
      (error) => {
        console.log(error);
      }
    );
  }

}
